export const MEDIA_ORDER_FILE_TYPES = {
  booking: 'booking_contract',
  reachReport: 'post_campaign_reach_report'
}
